import Swiper from "swiper";
import { Pagination, EffectFlip, EffectFade } from "swiper/modules";

class Slider {
    constructor($el) {
        this.$el = $el;
        this.$sliderEl = this.$el.find('[data-slider="slider"]');
        this.init();
    }

    init = () => {
        this.swiper = new Swiper(this.$sliderEl[0], {
            modules: [ Pagination],
            loop: true,
            //effect: 'slide',
            slidesPerView: 1,
            pagination: {
                el: this.$el.find('.custom-pagination')[0],
                clickable: true,
            },
        });
    }
}

export default Slider;
